export default "__VITE_ASSET__CGr6FuQR__"